(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const bars = document.querySelectorAll("[data-fsb-cart]");
    if (!bars.length) return;

    const formatAmount = (value, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "es-ES", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value) + " " + currency;
      } catch {
        return value.toFixed(2) + " " + currency;
      }
    };

    const renderBar = (bar, cart) => {
      const threshold = Number(bar.dataset.threshold || 0);
      const currency = bar.dataset.currency || cart.currency || "EUR";
      const prefix = bar.dataset.prefix || "Te faltan";
      const suffix = bar.dataset.suffix || "para envío gratis.";
      const success = bar.dataset.success || "Ya tienes envío gratis";
      const total = Number(cart.total_price || 0) / 100;
      const itemCount = Number(cart.item_count || 0);
      const message = bar.querySelector("[data-fsb-message]");
      const track = bar.querySelector("[data-fsb-track]");

      if (!itemCount || !threshold) {
        bar.style.display = "none";
        return;
      }

      const remaining = Math.max(threshold - total, 0);
      const progress = Math.min((total / threshold) * 100, 100);

      bar.style.display = "grid";
      bar.style.setProperty("--progress", `${progress}%`);

      if (track) {
        track.setAttribute("aria-valuenow", String(Math.round(progress)));
      }

      if (message) {
        message.textContent =
          remaining === 0
            ? success
            : `${prefix} ${formatAmount(remaining, currency)} ${suffix}`;
      }
    };

    let timeout;

    const refreshBars = async () => {
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        try {
          const response = await fetch("/cart.js", {
            headers: { Accept: "application/json" },
            credentials: "same-origin",
          });
          const cart = await response.json();
          bars.forEach((bar) => renderBar(bar, cart));
        } catch {
          // Si /cart.js falla, se mantienen los valores iniciales de Liquid.
        }
      }, 120);
    };

    ["cart:updated", "cart:refresh", "cart:change", "ajaxCart:updated"].forEach((eventName) => {
      document.addEventListener(eventName, refreshBars);
      window.addEventListener(eventName, refreshBars);
    });

    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const url = String(args[0]?.url || args[0] || "");

      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        refreshBars();
      }

      return response;
    };

    const originalOpen = window.XMLHttpRequest?.prototype.open;

    if (originalOpen) {
      window.XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        this.addEventListener("loadend", () => {
          const requestUrl = String(url || "");

          if (
            requestUrl.includes("/cart/add") ||
            requestUrl.includes("/cart/change") ||
            requestUrl.includes("/cart/update") ||
            requestUrl.includes("/cart/clear")
          ) {
            refreshBars();
          }
        });

        return originalOpen.call(this, method, url, ...rest);
      };
    }

    refreshBars();
  })();
  } catch(e) { console.error(e); }
})();

})();
